import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from '../../../components/Button';
import Search from '../../../components/inputs/Search';
import { openEditVariableDialog } from '../store';

const VariablesFilters = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(openEditVariableDialog({}));
  }, [dispatch]);

  return (
    <div className="cluster-4 items-center">
      <Search className="flex-1" />
      <Button data-testid="button-add-variable" type="primary" onClick={onAdd}>
        {t('addVariable')}
      </Button>
    </div>
  );
};

VariablesFilters.propTypes = {};

VariablesFilters.defaultProps = {};

export default VariablesFilters;
